import { Box, Typography } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import { formatDate } from './gewichtStatistikUtils';

// Nivo-Liniendiagramm des Gewichtsverlaufs inkl. Ziel-Marker.
function GewichtsverlaufChart({ nivoData, minY, maxY, zielMarker, tickCount, compact }) {
    return (
        <Box
            sx={{
                height: compact ? 220 : 300,
                width: '100%',
                minWidth: 0,
                position: 'relative',
            }}
        >
            <ResponsiveLine
                data={nivoData}
                margin={{
                    top: 10,
                    // Rechts mehr Platz für Ziel-Label
                    right: 6,
                    bottom: 50,
                    // Links schmaler auf Mobile halten
                    left: 30,
                }}
                // X-Achse ist ein Datum-String → als Kategorie behandeln
                xScale={{ type: 'point' }}
                yScale={{
                    type: 'linear',
                    min: minY,
                    max: maxY,
                    stacked: false,
                }}
                // Kurve leicht glätten
                curve="monotoneX"
                // Achsen-Stil
                axisBottom={{
                    tickSize: 4,
                    tickPadding: 6,
                    tickRotation: -35,
                    format: (v) => formatDate(v),
                    // Nur jeden n-ten Tick zeigen
                    tickValues: nivoData[0].data
                        .filter((_, i) => {
                            const total = nivoData[0].data.length;
                            if (total <= tickCount) return true;
                            const step = Math.ceil(total / tickCount);
                            return i % step === 0 || i === total - 1;
                        })
                        .map((d) => d.x),
                }}
                axisLeft={{
                    tickSize: 4,
                    tickPadding: 6,
                    tickRotation: 0,
                    format: (v) => `${v}`,
                    tickCount: 5,
                }}
                // Grid
                enableGridX={false}
                gridYValues={5}
                theme={{
                    grid: {
                        line: {
                            stroke: 'rgba(59, 130, 246, 0.1)',
                            strokeWidth: 1,
                        },
                    },
                    axis: {
                        ticks: {
                            text: {
                                fill: '#64748b',
                                fontSize: 11,
                            },
                            line: { stroke: '#64748b' },
                        },
                        domain: {
                            line: { stroke: '#334155' },
                        },
                    },
                    crosshair: {
                        line: {
                            stroke: '#3b82f6',
                            strokeWidth: 1,
                            strokeOpacity: 0.5,
                        },
                    },
                    tooltip: {
                        container: {
                            background: 'rgba(15, 23, 42, 0.95)',
                            border: '1px solid rgba(59, 130, 246, 0.3)',
                            borderRadius: '12px',
                            padding: '8px 12px',
                            color: '#e0f2fe',
                            fontSize: 13,
                        },
                    },
                }}
                // Linie
                colors={['#3b82f6']}
                lineWidth={3}
                // Punkte – auf Mobile etwas kleiner
                enablePoints={true}
                pointSize={6}
                pointColor="#3b82f6"
                pointBorderWidth={2}
                pointBorderColor="#1e293b"
                // Area unter der Linie
                enableArea={true}
                areaOpacity={0.15}
                // Tooltip
                useMesh={true}
                tooltip={({ point }) => (
                    <Box
                        sx={{
                            bgcolor: 'rgba(15, 23, 42, 0.95)',
                            border: '1px solid rgba(59, 130, 246, 0.3)',
                            borderRadius: '12px',
                            px: 1.5,
                            py: 1,
                        }}
                    >
                        <Typography
                            variant="caption"
                            sx={{ color: '#93c5fd', display: 'block', mb: 0.3 }}
                        >
                            {formatDate(point.data.x)}
                        </Typography>
                        <Typography
                            variant="body2"
                            fontWeight={600}
                            sx={{ color: '#e0f2fe' }}
                        >
                            {Number(point.data.y).toFixed(1)} kg
                        </Typography>
                    </Box>
                )}
                // Legende ausblenden (wird oben textuell angezeigt)
                legends={[]}
                // Ziel-Linie
                markers={zielMarker}
                // Kein animiertes Re-render bei Resize (besser für Mobile)
                animate={true}
                motionConfig="gentle"
            />
        </Box>
    );
}

export default GewichtsverlaufChart;
